import {Helmet} from '@dr.pogodin/react-helmet';
import {match} from 'ts-pattern';

import {isString} from 'ramda-adjunct';

import i18n from '@dms/i18n';
import {telephonyRoutes, testIds} from '@dms/routes';
import {catchUnhandledDataGridActions, DmsDataGrid, logError, Main} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

const TELEPHONY_CALL_GRID_CODE = 'telephony-call';

/**
 * Every stored call, both directions, as the backend grid defines it. The default preset shows the
 * viewer's own calls without a linked record; a manager clears the "mine" chip for the team's.
 */
export function TelephonyCallList() {
  const navigate = useNavigate();

  const actionCallback: ActionCallback = ({actionKey, rowId, sourceSearchParams}) => {
    // Bulk invocation of a single-row action is a misconfiguration — surface it to devs/Sentry.
    if (!isString(rowId)) {
      return logError(`Bulk invocation of single-row action ${actionKey} is not implemented`);
    }
    const callDetailPath = composePath(telephonyRoutes.callDetail, {
      params: {id: rowId},
      isSearchParamsPreserved: false,
      queryParams: sourceSearchParams,
    });
    match(actionKey)
      .with('detail', () => navigate(callDetailPath))
      .with('detail_newTab', () => window.open(callDetailPath))
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  return (
    <>
      <Helmet title={i18n.t('page.telephony.thread.callsFilter')} />
      <Main
        isFullHeight
        heading={i18n.t('page.telephony.thread.callsFilter')}
        data-testid={testIds.telephony.calls('page')}
      >
        <DmsDataGrid
          gridCode={TELEPHONY_CALL_GRID_CODE}
          actionCallback={actionCallback}
          data-testid={testIds.telephony.calls('grid')}
        />
      </Main>
    </>
  );
}
